import React from 'react';
import { PawPrint, Clock, Bell } from 'lucide-react';
import { Button } from '../ui/button';
import { avantages } from '../../data/mock';
import { Link } from 'react-router-dom';

const iconMap = {
  PawPrint: PawPrint,
  Clock: Clock,
  Bell: Bell,
};

const AdvantagesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Advantages List */}
          <div className="space-y-8">
            {avantages.map((item, index) => {
              const IconComponent = iconMap[item.icon];
              return (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-14 h-14 bg-green-100 rounded-2xl flex items-center justify-center">
                    {IconComponent && <IconComponent className="w-7 h-7 text-green-600" />}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}

            <Link to="/recherche">
              <Button className="bg-green-500 hover:bg-green-600 text-white rounded-full px-8 py-3 mt-4 transition-all duration-200 shadow-lg shadow-green-500/25">
                Prendre rendez-vous
              </Button>
            </Link>
          </div>

          {/* Right - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&h=500&fit=crop"
                alt="Vétérinaire avec animaux"
                className="w-full h-auto object-cover"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-green-900/20 to-transparent"></div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-green-200/50 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-emerald-200/50 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
